export function isRouteAllowed(pathname) {
    const isLoaded = localStorage.getItem("permissionsLoaded");

    if (!isLoaded) {
        console.log("Permissions not loaded yet");
        return null;
    }

    const permissions =
        JSON.parse(localStorage.getItem("permissions")) || [];

    console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
    console.log("Checking Route Permission");
    console.log("Pathname:", pathname);
    console.log("Permissions:", permissions);

    const result = permissions.some((p) => {
        const comparison1 = pathname === p.url;
        const comparison2 = pathname.startsWith((p.url || "") + "/");

        // New shape: actions array of granted slugs. Legacy shape: view boolean.
        const viewAllowed = Array.isArray(p.actions)
            ? p.actions.includes("view")
            : p.view === true;

        console.log("---- Comparing ----");
        console.log("Permission URL:", p.url);
        console.log("View Allowed:", viewAllowed);
        console.log("pathname === p.url ?", comparison1);
        console.log(
            "pathname.startsWith(p.url + '/') ?",
            comparison2
        );

        return viewAllowed && (comparison1 || comparison2);
    });

    console.log("Final Allowed Result:", result);
    console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");

    return result;
}
